"use strict";
var Constants = (function () {
    function Constants() {
    }
    return Constants;
}());
// Dates
Constants.DATE_PARSE_FORMAT = 'YYYY-MM-DD';
Constants.DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
// Coverages
Constants.COVERAGE_CFAR = 'CFAR';
// Products
Constants.MICRO_RATING_ID = '1';
// Ages
Constants.MINIMUM_AGE = 0;
Constants.MAXIMUM_AGE = 120;
exports.Constants = Constants;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/constants.js